import { Message } from "@/types/Message";

export function removeRecallMsg(msgs: Message[]) {
    const microtimesArr = msgs
      .filter((msg) => {
        return msg.type === "recall";
      })
      .map((msg) => msg.recall_microtime);
  
    const toBeRecalled: number[] = [];
  
    msgs.forEach((item, index) => {
      const microtime = item.originalMicrotime || item.microtime;
      if (item.type !== "recall" && microtimesArr.includes(microtime)) {
        toBeRecalled.push(index);
      }
    });
    return msgs.map((_, index) => {
      if (toBeRecalled.includes(index)) {
        return getRecalledMsg(_);
      }
      return _;
    });
  }
  
  export function isInRecallTimeMargin(microtime: number) {
    const now = Date.now();
  
    if (microtime.toString().length === 16) {
      microtime = Math.floor(microtime / 1000);
    }
  
    // 2分钟内的消息可以撤回
    return now - microtime < 2 * 60 * 1000;
  }
  
  function getRecalledMsg(_: Message) {
  
  
    return {
      ..._,
      recalled: 1,
    };
  }